module.exports = __webpack_public_path__ + "img/elektronika.228b19ff.svg";